export default {
    "main": "Bán chính",
    "gift": "Quà tặng",
}
